import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import DataCaptureForm from '../components/DataCaptureForm/DataCaptureForm';

var DataCapturePage = function DataCapturePage(props) {
  return React.createElement(
    'div',
    { className: 'data-capture-page' },
    React.createElement(DataCaptureForm, {
      handleFormSubmitDiscountCode: props.handleFormSubmitDiscountCode,
      formDiscount: props.formDiscount,
      isModal: true // Allows success message to appear
    })
  );
};

DataCapturePage.propTypes = {
  handleFormSubmitDiscountCode: PropTypes.func,
  formDiscount: PropTypes.object
};

export default DataCapturePage;